import React from 'react'
import { useSelector } from 'react-redux';
import { getCurrentStepInfo, getProgressPercentage, STAGE_STEPS } from '../../../../config/stageConfig';

function TitleCard() {

    const { userData } = useSelector(state => state.auth)
    const { applicationDetail } = useSelector(state => state.dashboard)
    const { grade, customerName } = useSelector(state => state.eligibility)
    const urlParams = new URLSearchParams(window.location.search);
    const referenceId = urlParams.get('referenceId');
    // Split referenceId into first 10 and next 9 characters
    const referenceIdPart1 = referenceId ? referenceId.substring(0, 10) : '';
    const referenceIdPart2 = referenceId ? referenceId.substring(10, 19) : '';

    // Get stage and subStage for dynamic stepper
    const { stage, subStage, productDetailsData } = useSelector(state => state.eligibility)
    const { currentStep, totalSteps } = getCurrentStepInfo(stage, subStage);

    // Helper function to get step status
    const getStepStatus = (stepNumber) => {
        if (stepNumber < currentStep) return 'complete';
        if (stepNumber === currentStep) return 'active';
        return 'pending';
    }

    const getStepStatusText = (stepNumber) => {
        if (stepNumber < currentStep) return 'Completed';
        if (stepNumber === currentStep) return 'In-progress';
        return 'Pending';
    }
    // Get logged in user name
    const loggedInUserName = userData?.response_data?.data?.userName || '';

    // Get dealer information from application detail
    const dealerCode = applicationDetail?.dealer_code || ""
    const dealerData = userData?.response_data?.dealer_data || []
    const selectedDealer = dealerData.find(dealer => dealer.dealercode === dealerCode)
    const dealerName = applicationDetail?.dealer_name || ""

    return (
        <div className="col-md-3 col-sm-12 SideLeft">
            <div className=" main-section">
                <div className="dealer-body tab-dealer-body">
                    <div className="row">
                        <div className="col-12">
                            <div className="class-dealer-created-tag">
                                <div className="d-flex justify-content-between gap-2 ">
                                    <div className="name-detail-tag">
                                        <div className="ribbon-12 left ribbon-syle">
                                            <span className="pe-2">{referenceIdPart1}</span>
                                            <span className="ps-2 text-white">{referenceIdPart2}</span>
                                        </div>
                                    </div>
                                    <div className="info-block text-end">
                                        <div className="small current-primary fw-semibold header-dealer-name-text info-name">{dealerName ? dealerName
                                            : "No dealer selected"
                                        }
                                        </div>
                                        <div className="grade-box position-relative">
                                            <div className="grade-plus">{grade === 'A' ? '++' : grade === 'B' ? '+' : ''}</div>
                                            <div className="grade-base">{`A`}</div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="fw-semibold mb-0 current-primary bottom-text">{customerName || "-"}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {stage === 'credit_decision' ? (
                <div className="webstepper SideScroll tab-basic-details-stepper">
                    <p className="dark-blue fw-semibold">Complete steps</p>
                    <p className="small">You are few steps away from obtaining your<br />Consumer Durable Loan</p>
                    <div className="steps-vertical">
                        <div className="step-vertical active">
                            <div className="step-vertical-icon"></div>
                            <div className="step-vertical-content">
                                <p className="stp">Step 1</p>
                                <h6 className="name">Basic Details</h6>
                                <p className="status">In-progress</p>
                            </div>
                        </div>
                        <div className="step-vertical pending">
                            <div className="step-vertical-icon"></div>
                            <div className="step-vertical-content">
                                <p className="stp">Step 2</p>
                                <h6 className="name">KYC</h6>
                                <p className="status">Pending</p>
                            </div>
                        </div>
                        <div className="step-vertical pending">
                            <div className="step-vertical-icon"></div>
                            <div className="step-vertical-content">
                                <p className="stp">Step 3</p>
                                <h6 className="name">Product Details</h6>
                                <p className="status">Pending</p>
                            </div>
                        </div>
                        <div className="step-vertical pending">
                            <div className="step-vertical-icon"></div>
                            <div className="step-vertical-content">
                                <p className="stp">Step 4</p>
                                <h6 className="name">Bank Details</h6>
                                <p className="status">Pending</p>
                            </div>
                        </div>
                        <div className="step-vertical pending">
                            <div className="step-vertical-icon"></div>
                            <div className="step-vertical-content">
                                <p className="stp">Step 5</p>
                                <h6 className="name">Documents</h6>
                                <p className="status">Pending</p>
                            </div>
                        </div>
                        <div className="step-vertical pending">
                            <div className="step-vertical-icon"></div>
                            <div className="step-vertical-content">
                                <p className="stp">Step 6</p>
                                <h6 className="name">IMEI Validation</h6>
                                <p className="status">Pending</p>
                            </div>
                        </div>
                        <div className="step-vertical pending">
                            <div className="step-vertical-icon"></div>
                            <div className="step-vertical-content">
                                <p className="stp">Step 7</p>
                                <h6 className="name">Invoice Details</h6>
                                <p className="status">Pending</p>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="webstepper SideScroll">
                    <p className="dark-blue fw-semibold">Complete steps</p>
                    <p className="small">You are few steps away from obtaining your<br />Consumer Durable Loan</p>
                    <div className="steps-vertical">
                        {STAGE_STEPS.map((stageStep, index) => {
                            const stepStatus = getStepStatus(stageStep.step);
                            const statusText = getStepStatusText(stageStep.step);
                            return (
                                <div key={stageStep.key} className={`step-vertical ${stepStatus}`}>
                                    <div className="step-vertical-icon">
                                        {stepStatus === 'complete' && <i className="icon-Essetional-Tick-1"></i>}
                                    </div>
                                    <div className="step-vertical-content">
                                        <p className="stp">Step {stageStep.step}</p>
                                        <h6 className="name">{stageStep.name}</h6>
                                        <p className="status">{statusText}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    )
}

export default TitleCard